'use client';
import React, { useState } from 'react';

const RunnerText = ({ runnerTexts }) => {
  const [isPaused, setIsPaused] = useState(false);

  return (
    <div className="mx-auto bg-white px-2 md:px-4 py-2">
      <div
        className="overflow-hidden bg-[#FDF6EC] border border-[#fcd4b1] shadow-md w-full"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}>
        <div className={`h-7 flex whitespace-nowrap items-center ${isPaused ? 'paused-marquee' : 'animate-marquee'}`}>
          {runnerTexts.map((text, idx) => (
            <span className="mx-8 text-sm font-bold text-[#1F1F1F]" key={text.id || idx}>
              <a target="_blank" href={text?.pageUrl} rel="noopener noreferrer">
                <div style={{ fontFamily: 'Arial !important' }} dangerouslySetInnerHTML={{ __html: text?.text ?? '' }} />
              </a>
            </span>
          ))}
        </div>
        <style>{`
                    @keyframes marquee {
                        0% {
                            transform: translateX(100%);
                        }
                        100% {
                            transform: translateX(-100%);
                        }
                    }
                    .animate-marquee {
                        animation: marquee 25s linear infinite;
                    }
                    .paused-marquee {
                        animation-play-state: paused !important;
                        animation: marquee 25s linear infinite;
                    }
                `}</style>
      </div>
    </div>
  );
};

export default RunnerText;
